export default __webpack_public_path__ + "static/media/messenger_veryDarkGrey.c9e7554c.svg";